module.exports = __webpack_public_path__ + "img/delete-gray.7359cd87.svg";